import type { AppContentCurrentEntity } from '../entities/app-content.entity';
import type { GetAppContentUseCase } from './get-app-content.usecase';

export class GetPrivacyPolicyUseCase {
  constructor(private readonly getAppContent: GetAppContentUseCase) {}

  execute(): Promise<AppContentCurrentEntity | null> {
    return this.getAppContent.executeCurrent('privacyPolicy');
  }
}
